'use client'

import { frbSetUserProperties } from '@/helpers/analytics.helper'
import constants from '@/helpers/constants'
import { useRouter } from 'next/navigation'
import { createContext, useContext, useState, useEffect } from 'react'
import { decryptData } from '@/helpers/crypto'

const AuthContext = createContext()

export function AuthProvider ({ children }) {
  // Initialize from localStorage if available
  const [isLoggedIn, setIsLoggedIn] = useState(null)
  const [user, setUser] = useState(null)
  const [fromLogin, setFromLogin] = useState(null)

  const router = useRouter()

  // Persist isLoggedIn to localStorage
  useEffect(() => {
    // console.log('Setting isLoggedIn in localStorage:', isLoggedIn)
    if (isLoggedIn === null) return // Avoid setting null
    localStorage.setItem('isLoggedIn', isLoggedIn ? 'true' : 'false')
  }, [isLoggedIn])

  useEffect(() => {
    // Check if user is logged in on initial load
    const storedIsLoggedIn = localStorage.getItem('isLoggedIn')
    // console.log('AuthProvider mounted', { storedIsLoggedIn })
    if (storedIsLoggedIn === 'true') {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  }, [])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(constants.BASE_URL + '/auth/user-profile')
        const result = await res.json()
        const data = result.encrypted ? decryptData(result.encrypted) : result
        if (data.code == 200) {
          setUser(data.data)
          setIsLoggedIn(true)
        } else {
          setUser(null)
          if (data.message == 'Unauthorized') {
            setIsLoggedIn(false)
          }
          console.log('Failed to fetch user profile:', data)
        }
      } catch (e) {
        console.log('Error fetching user profile:', e)
        setUser(null)
      }
    }
    if (isLoggedIn) fetchUser()
  }, [isLoggedIn])

  const login = () => {
    setIsLoggedIn(true)
    setFromLogin(true)
    frbSetUserProperties({
      login_status: 'Web logged in'
    })
  }
  const logout = () => {
    setIsLoggedIn(false)
    setUser(null)
    router.replace('/login')
    frbSetUserProperties({
      login_status: 'Web non logged in'
    })
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        login,
        logout,
        user,
        setUser,
        fromLogin,
        setFromLogin
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth () {
  return useContext(AuthContext)
}
